"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.name = void 0;
const React = __importStar(require("react"));
const react_native_1 = require("react-native");
const native_base_1 = require("native-base");
const theme_1 = require("theme");
const icons_1 = __importDefault(require("constants/icons"));
const native_1 = require("@react-navigation/native");
const hooks_1 = require("components/hooks");
const requirement_1 = require("services/requirement");
const RequirementRequest = ({ navigation }) => {
    const client = (0, hooks_1.useClient)();
    const [roadmaps, setRoadmaps] = React.useState();
    const onAddPressed = () => {
        navigation.navigate({
            name: "RequirementRequestAddName",
            params: {
                client: client,
                clear: true,
                id: undefined,
            },
            merge: true,
        });
    };
    const onEditPressed = (item) => {
        navigation.navigate("RequirementRequestAddName", {
            client: null,
            id: item.id,
        });
    };
    const [initialLoading, setInitialLoading] = React.useState(false);
    const [isLoading, setLoading] = React.useState(false);
    const [currentPage, setCurrentPage] = React.useState(1);
    const lastPage = React.useRef(0);
    const listRoadmaps = React.useCallback(() => {
        const onSuccess = (response) => {
            lastPage.current = response.pages ?? 0;
            setRoadmaps(response.data);
        };
        if (client?.id)
            (0, requirement_1.doRequirementList)({
                callback: {
                    onSuccess,
                    onLoading: setInitialLoading,
                },
                params: {
                    data: {
                        cardCode: client?.id,
                        page: "1",
                    },
                },
            });
    }, [client?.id]);
    const listMoreRoadmaps = React.useCallback(() => {
        let nextPage = currentPage + 1;
        const onSuccess = (response) => {
            lastPage.current = response.pages ?? 0;
            if ((response.data?.length ?? 0) > 0) {
                setRoadmaps(quotes => [...(quotes ?? []), ...(response.data ?? [])]);
                setCurrentPage(nextPage);
            }
        };
        (0, requirement_1.doRequirementList)({
            callback: {
                onSuccess,
                onLoading: setLoading,
            },
            params: {
                data: {
                    cardCode: client?.id,
                    page: nextPage.toString(),
                },
            },
        });
    }, [currentPage, lastPage, client?.id]);
    (0, native_1.useFocusEffect)(listRoadmaps);
    const renderItem = ({ item }) => (<RequirementItem item={item} onPress={() => {
            onEditPressed(item);
        }}/>);
    return (<native_base_1.ScrollView style={{ width: "100%" }} _contentContainerStyle={{
            alignItems: "center",
            px: {
                base: 15,
                md: 15,
            },
        }}>
			<native_base_1.View w={{ base: "100%", md: "90%", lg: "75%", xl: "65%" }} pb="10">
				<native_base_1.VStack mt="30" alignItems="start">
					<native_base_1.Pressable onPress={onAddPressed}>
						<native_base_1.HStack alignItems="center" background={theme_1.Colors.colorLightGray1} borderRadius={20} px={15} py={5}>
							<native_base_1.Image alt="_" source={icons_1.default.icPlus} width={10} h={10} mr={5}/>
							<native_base_1.Text>Agregar requerimiento</native_base_1.Text>
						</native_base_1.HStack>
					</native_base_1.Pressable>
					<native_base_1.View h={20}/>
					<native_base_1.FlatList w="100%" h="100%" px="20" data={roadmaps} renderItem={renderItem} numColumns={1} key={1} ListFooterComponent={() => (<native_base_1.View style={{ marginBottom: 300 }}>{isLoading && <native_base_1.Spinner size="lg" color="black"/>}</native_base_1.View>)} onScroll={e => {
            let paddingToBottom = 3000;
            paddingToBottom += e.nativeEvent.layoutMeasurement.height;
            var currentOffset = e.nativeEvent.contentOffset.y;
            var direction = currentOffset > 99999999999999999 ? "down" : "up"; //this?.offset ? "down" : "up";
            if (direction === "up") {
                if (e.nativeEvent.contentOffset.y >=
                    e.nativeEvent.contentSize.height - paddingToBottom) {
                    if (!isLoading && currentPage < lastPage.current) {
                        setTimeout(() => {
                            listMoreRoadmaps();
                        }, 10);
                    }
                }
            }
        }}/>
				</native_base_1.VStack>
			</native_base_1.View>
		</native_base_1.ScrollView>);
};
const RequirementItem = ({ item, onPress }) => {
    return (<native_base_1.Pressable onPress={onPress}>
			<native_base_1.VStack py={20} borderBottomWidth={1} borderBottomColor={theme_1.Colors.colorLightGray1}>
				<native_base_1.HStack alignItems="center" py={5}>
					<native_base_1.Text mr="10" variant="body23">
						{item.code ?? ""}
					</native_base_1.Text>
					{/*
        <Pressable onPress={onPress}>
        <View p={10}>
            <Image
                alt="_"
                source={icons.icEye}
                w={27}
                h={27}
                style={{tintColor: "black"}}
            />
        </View>
    </Pressable>
        */}

					<native_base_1.View flex={1}/>
					<native_base_1.Text bg={`${item.estadoColor ?? "#ffffff"}`} borderRadius={20} px={10} py="2">
						{item.estadoName ?? ""}
					</native_base_1.Text>
				</native_base_1.HStack>
				<native_base_1.HStack alignItems="center" py={5}>
					<native_base_1.Text mr={10}>Tipo:</native_base_1.Text>
					<native_base_1.Text flex={1} mr={20} color={theme_1.Colors.colorDarkGray1}>
						{item.tipoName ?? ""}
					</native_base_1.Text>
					<native_base_1.Text mr={10} color={theme_1.Colors.colorDarkGray1}>
						F. Registro:
					</native_base_1.Text>
					<native_base_1.Text>{item.fecha ?? ""}</native_base_1.Text>
				</native_base_1.HStack>
			</native_base_1.VStack>
		</native_base_1.Pressable>);
};
const styles = react_native_1.StyleSheet.create({
    layoutContainer: {
        width: "100%",
    },
});
exports.name = "RequirementRequestName";
exports.default = RequirementRequest;
